import styled from '@emotion/styled'

export const BannerContainer = styled.div`
  border-radius: 8px;
  background: #e8f7fe;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 15px 20px;
  width: 100%;
`
